import AnsattLandingPage from '../../components/AnsattPage/AnsattLandingPage';
import { getAnsattStaticProps, ANSATT_STATIC_PATHS } from '../../lib/fetch-ansatt-page';

export async function getStaticPaths() {
  return ANSATT_STATIC_PATHS;
}

export async function getStaticProps({ params }) {
  return getAnsattStaticProps(params, 'no');
}

export default function AnsattPage(props) {
  return <AnsattLandingPage {...props} languageCode="no" />;
}
